import VueRouter from 'vue-router'
import Preload from './pages/Preload.vue'
import Lazyload from './pages/Lazyload.vue'
import Login from './pages/Login.vue'
import ProductList from './pages/ProductList.vue'

const router = new VueRouter({
    //mode: 'history', // default is hash
    routes: [
        { path: '/', component: Preload },
        { path: '/login', component: Login },
        { path: '/lazyload', component: Lazyload },
        { path: '/products', component: ProductList }
    ]
})

export default router



// WEBPACK FOOTER //
// ./src/router.js